module.exports = __webpack_public_path__ + "static/media/ss13_preview.6260ad69.jpg";